import styled from 'styled-components';
import {rem} from 'polished';

const MenuItem = styled.li`
  margin: ${rem(20)} ${rem(10)};
`;

export default MenuItem;